<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="权限名称">
              <a-input v-model.trim="queryParam.privilegeName" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="8" :sm="24">
            <a-form-item label="所属菜单">
              <a-select
                showSearch
                :filterOption="filterOption"
                v-model="queryParam.menuId"
                default-value="0"
                placeholder="请选择">
                <a-select-option v-for="(item, index) in menuSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->
          <a-col :md="8" :sm="24">
            <a-form-item label="所属菜单">
              <a-cascader
                :options="treeData"
                :showSearch="{filter}"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                v-model="queryParam.menuId"
                notFoundContent="暂无数据"
                expandTrigger="hover"
                placeholder="请选择所属菜单"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="540"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="权限名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.privilegeName"
            placeholder="权限名称"
            v-decorator="['privilegeName',
                          { initialValue: mdl.privilegeName, rules: [{ required: true, message: '请输入权限名称'}]}]"
          />
        </a-form-item>

        <a-form-item label="权限代号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.privilegeCode"
            placeholder="权限代号"
            v-decorator="['privilegeCode',
                          { initialValue: mdl.privilegeCode, rules: [{ required: true, message: '请输入权限代号'}]}]"
          />
        </a-form-item>

        <a-form-item label="所属菜单" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.menuId"
            placeholder="所属菜单"
          >
            <a-select-option
              v-for="(item, index) in menuSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { privilegePage, privilegeUpdate, privilegeSave, privilegeDelete, menuList, menuTree } from '@/api/sys'

export default {
  name: 'Privillege',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      treeData: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '权限名称',
          dataIndex: 'privilegeName'
        },
        {
          title: '权限代号',
          dataIndex: 'privilegeCode'
        },
        {
          title: '所属菜单',
          dataIndex: 'menuName'
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 所属菜单下拉
      menuSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log(this.queryParam)
        let zz = {}
        if (this.queryParam.menuId && this.queryParam.menuId.length > 0) {
          zz['menuId'] = this.queryParam.menuId[this.queryParam.menuId.length - 1]
        }
        if (this.queryParam.privilegeName) {
          zz['privilegeName'] = this.queryParam.privilegeName
        }
        return privilegePage(Object.assign(parameter, zz)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadMenuSelect()
  },
  methods: {
    loadMenuSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = menuList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.menuSelect = res
      })
      new Promise(resolve => {
        const data = menuTree({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        let trees = [{name: '全选',id: undefined}, {name: '无所属菜单', id:"000"}]
        trees.push()
        this.treeData = trees.concat(res)
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            privilegeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            privilegeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return privilegeDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {
          nthis.$message.info('哦豁，我又存活下来啦')
          nthis.$emit('ok')
        }
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
